import type { BudgetI } from "./types";

export type BudgetDetail = Omit<BudgetI, "categories">;

/**
 * Budget page header state from the budget GET. Categories live separately in sheet data.
 * `rerun_params` seeds the Budget assumptions dialog and is re-sent by targeted rebudget.
 */
export function toBudgetDetail(budget: BudgetI): BudgetDetail {
  return {
    rerun_params: budget.rerun_params ?? null,
    ...(budget.rerun_params_notice ? { rerun_params_notice: budget.rerun_params_notice } : {}),
    estimated_shoot_days: budget.estimated_shoot_days,
    assumptions: budget.assumptions,
    tax_incentives: budget.tax_incentives,
    contingency_percentage: budget.contingency_percentage,
    contingency_actual: budget.contingency_actual,
    contingency_locked: budget.contingency_locked,
    locked: budget.locked ?? false,
    created_at: budget.created_at,
    budget_id: budget.budget_id,
    document_id: budget.document_id,
    bond_fee_percentage: budget.bond_fee_percentage,
    updated_at: budget.updated_at,
    currency: budget.currency,
    document: budget.document,
  };
}
